module.exports = __webpack_public_path__ + "static/media/ProfessionalPositioning.53c6a663.svg";